import { IStoreState } from 'src/store';
import { connect } from 'react-redux';
import { CustomerActionCreator, FrameworkActionCreator, RepairOrdersActionCreator, VehiclesActionCreator } from 'src/store/states';
import VerifyIdentity from '../VerifyIdentity';

const mapStateToProps = (state: IStoreState) => ({
    identityVerified: state.Customer.identityVerified,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    contactMethods: state.Customer.mfaContact,
    sentSecurityCode: state.Customer.sentSecurityCode,
    errMsg: state.Customer.errMsg,
    verifyingIdentity: state.Customer.verifyingIdentity,
    nameId: state.Customer.Customer.nameId,
    login: state.Customer.Customer.login,
    vehicleList: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    apptVehVin: state.Appointment.ApptVeh.vin,
    serviceDocsFlag: state.Framework.serviceDocsFlag,
    locale: state.Framework.locale,
    theme: state.Framework.theme,
});

const mapDispatchToProps = {
    sendSecurityCode: CustomerActionCreator.SendSecurityCode,
    verifyIdentity: CustomerActionCreator.VerifyIdentity,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    clearError: CustomerActionCreator.clearError,
    getVehicles: VehiclesActionCreator.GetVehicles,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    getExCustomer: CustomerActionCreator.GetExCust,
    fetchROs: RepairOrdersActionCreator.FetchROs,
    getExCust: CustomerActionCreator.GetExCust,
    setProfileOpen: FrameworkActionCreator.SetProfileOpen,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    setVerifyingIdentity: CustomerActionCreator.SetVerifyingIdentity,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VerifyIdentity);